import axios from '@/lib/axios-instance';
import { APIUrlGenerator } from '@/lib/helper';

import { SETTING_KEY } from '@/components/app/dynamic-content/services/type';

import { API_ROUTES } from '@/constant/routes';
import PagesSettingModel from '@/models/pages-setting.model';

export async function getDynamicPagesList() {
  const {
    data: { payload },
  }: { data: { payload: PagesSettingModel[] } } = await axios.get(
    APIUrlGenerator(API_ROUTES.GET_SETTINGS(SETTING_KEY.PAGES)),
  );
  return payload;
}

export async function getDynamicPageContent(pageId: string) {
  const {
    data: { payload },
  }: { data: { payload: string } } = await axios.get(
    APIUrlGenerator(API_ROUTES.GET_SETTINGS(`${SETTING_KEY.PAGE_CONTENT}${pageId}`)),
  );
  return payload;
}
